import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e0ca1134&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e0ca1134&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ca1134",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0ca1134')) {
      api.createRecord('e0ca1134', component.options)
    } else {
      api.reload('e0ca1134', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e0ca1134&scoped=true", function () {
      api.rerender('e0ca1134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/recordManage/index.vue"
export default component.exports